export default {
    poweredBy: "供电"
}